export default {
    modules: [
        {
            name: 'MODULE_SCHEDULEGENIE',
            url: 'http://localhost:8082/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_CONCESSIONMANAGER',
            url: 'http://localhost:8083/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_CALLUS',
            url: 'http://localhost:8084/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_NOTIFICATIONBANNER',
            url: 'http://localhost:8085/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_TEXTUS',
            url: 'http://localhost:8086/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_INCOMECALCULATOR',
            url: 'http://localhost:8087/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_BPN',
            url: 'http://localhost:8088/remoteEntry.js',
            module: './Module'
        },
        {
            name: 'MODULE_CHATBOT',
            url: 'http://localhost:8089/remoteEntry.js',
            module: './Module'
        }
    ]
};
